import { applyEmptyChartState, seriesHasData } from '@/data/chartEmptyState.js'

export function getChartOptions(totalCpu, _dataArray) {

  var dataArray = Object.assign({shortterm: [], midterm: [], longterm: []}, _dataArray)

  var dataSeries = {
    name: '',
    type: 'line',
    smooth: true,
    showSymbol: false,
    areaStyle: {
      opacity: 0.1
    },
    lineStyle: {
      width: 1
    },
    data: []
  };



  var options = {
    animation: false,
    title: {
      text: ''
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    legend: {
      orient: 'horizontal',
      bottom: '4%'
    },
    grid: {
      top: '3%',
      left: '3%',
      right: '4%',
      bottom: '15%',
      containLabel: true
    },
    toolbox: {
      show: false,
      feature: {
        restore: {},
      },
    },
    xAxis: {
      type: 'time',
      boundaryGap: false
    },
    yAxis: {
      type: 'value', min: 0
    },
    series: []
  }

  if (dataArray.shortterm.length > 0) {
    const arr = Object.assign({}, dataSeries);
    arr.id = '1min'
    arr.name = '1 Min'
    arr.data = dataArray.shortterm
    options.series.push(arr);
  }
  if (dataArray.midterm.length > 0) {
    const arr = Object.assign({}, dataSeries);
    arr.id = '5mins'
    arr.name = '5 Mins'
    arr.data = dataArray.midterm
    options.series.push(arr);
  }
  if (dataArray.longterm.length > 0) {
    const arr = Object.assign({}, dataSeries);
    arr.id = '15mins'
    arr.name = '15 Mins'
    arr.data = dataArray.longterm
    options.series.push(arr);
  }

  return applyEmptyChartState(options, seriesHasData(options.series));
} 